module.exports = __webpack_public_path__ + "img/epay-zy.b1ecedb3.png";